'use client';

import type { Placement } from '@floating-ui/react';
import type { CSSProperties } from 'react';

export function ArrowComponent({
  placement,
  style,
}: {
  placement: Placement;
  style?: CSSProperties;
}) {
  const getArrowClass = () => {
    if (placement.startsWith('top')) {
      return 'tooltip-arrow-top';
    } else if (placement.startsWith('bottom')) {
      return 'tooltip-arrow-bottom';
    } else if (placement.startsWith('left')) {
      return 'tooltip-arrow-left';
    } else if (placement.startsWith('right')) {
      return 'tooltip-arrow-right';
    }
    return '';
  };

  return <div className={`tooltip-arrow ${getArrowClass()}`} style={style} />;
}
